import React from 'react';
import { Card, CardImg, CardTitle, CardColumns, CardBody } from 'reactstrap';
import { useHistory, NavLink } from 'react-router-dom';
import LazyLoad from 'react-lazyload';

import './Card.scss';

import c from '../../config';
import { isExternalURL, parseSanitizedHTML } from '../../utils/Helper';

const Cards = (props) => {
  const history = useHistory();
  const { cards, homeCardCustomBodyInd } = props;

  const cardColumnsProps = homeCardCustomBodyInd && {
    className: 'cardBodyCustomLayout',
  };

  return (
    <CardColumns {...cardColumnsProps}>
      {cards.map((v, k) => {
        const item = v;

        const onCardClick = () => {
          if (isExternalURL(item.landing_url)) {
            window.open(item.landing_url, '_blank');
          } else {
            history.push(c.routePathTo + item.landing_url);
          }
        };

        const cardProps =
          item.landing_url !== '' && !homeCardCustomBodyInd
            ? {
                onClick: onCardClick,
                className: 'cursor-pointer',
                role: 'button',
              }
            : {};

        const cardCustomProps = homeCardCustomBodyInd && {
          style: {
            backgroundImage: `url(${item.image})`,
          },
        };

        const imgHTML = !homeCardCustomBodyInd && (
          <LazyLoad>
            <CardImg top width="100%" src={item.image} alt={item.image_alt_text} />
          </LazyLoad>
        );

        const customBg = homeCardCustomBodyInd && <div className="tb_bg">&nbsp;</div>;

        const cardLink =
          homeCardCustomBodyInd &&
          item.landing_url !== '' &&
          (isExternalURL(item.landing_url) ? (
            <a
              href={item.landing_url}
              target="_blank"
              rel="noopener noreferrer"
              className="card-link"
            >
              {item.title}
            </a>
          ) : (
            <NavLink
              className="card-link"
              to={(location) => ({ ...location, pathname: c.routePathTo + item.landing_url })}
            >
              {item.title}
            </NavLink>
          ));

        return (
          <Card key={k} {...cardProps} {...cardCustomProps}>
            {imgHTML}
            <CardBody>
              <CardTitle>{item.title}</CardTitle>
              <div className="card-text">
                <div className="card-Content">{parseSanitizedHTML(item.description)}</div>
                {customBg}
              </div>
            </CardBody>
            {cardLink}
          </Card>
        );
      })}
    </CardColumns>
  );
};

export default Cards;
